import React from 'react';
import { StyledSelectComponent, StyledInput } from './styles';
import { MenuItem } from '@material-ui/core';
export var StyledSelectDropdownSkeleton = function StyledSelectDropdownSkeleton() {
  return /*#__PURE__*/React.createElement(StyledSelectComponent, {
    value: "loading",
    disabled: true,
    input: /*#__PURE__*/React.createElement(StyledInput, null)
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "loading"
  }, "Loading..."));
};
export default StyledSelectDropdownSkeleton;